import { ApiClient } from "@common/services/ApiClient"
import userManager from "../userManager"

export default new ApiClient("core-api", undefined, options => {
    options.requestInterceptor = req => {
        const tenantCode = userManager.tenantCode()
        if (tenantCode) {
            req.headers["x-tenant-code"] = tenantCode
        }
    }
    return options
}, params => {
    const tenantCode = userManager.tenantCode()
    if (tenantCode) {
        params.x_tenant_code = tenantCode
    }
    return params
})
